import styled from "styled-components";
import { Flex, transition } from "@evergis/ui";

import { FILTERED_VALUE_OPACITY } from "../../constants";

export const StackBarContainer = styled(Flex)`
  flex-wrap: nowrap;
  width: 100%;
`;

export const StackBarHeader = styled(Flex)`
  justify-content: space-between;
  margin-bottom: 0.375rem;
  font-size: 0.75rem;
`;

export const StackBarSection = styled.div<{
  $width: string;
  $height?: string | number;
  $color: string;
  cornerRadius: number;
  hasAnyFilter?: boolean;
  isFiltered?: boolean;
  onClick?: (value: string) => void;
}>`
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  width: ${({ $width }) => $width}%;
  height: ${({ $height }) => ($height ? `${$height}px` : "0.5rem")};
  margin: 0 0.5px;
  background-color: ${({ $color }) => $color};
  opacity: ${({ hasAnyFilter, isFiltered }) => (isFiltered ? 1 : hasAnyFilter ? FILTERED_VALUE_OPACITY / 100 : 1)};
  transition: opacity ${transition.release};

  :first-child {
    border-top-left-radius: ${({ cornerRadius }) => (cornerRadius ? `${cornerRadius}px` : "0.5rem")};
    border-bottom-left-radius: ${({ cornerRadius }) => (cornerRadius ? `${cornerRadius}px` : "0.5rem")};
  }

  :last-child {
    border-top-right-radius: ${({ cornerRadius }) => (cornerRadius ? `${cornerRadius}px` : "0.5rem")};
    border-bottom-right-radius: ${({ cornerRadius }) => (cornerRadius ? `${cornerRadius}px` : "0.5rem")};
  }
`;

export const StackBarAlias = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
`;

export const StackBarTotal = styled(Flex)``;

export const StackBarValue = styled.div``;

export const StackBarUnits = styled.div`
  margin-left: 0.25rem;
  color: ${({ theme: { palette } }) => palette.textSecondary};
`;
